<template>
  <v-main>
    <vue-particles
      :key="particleKey"
      class="vue-particles-background"
      color="#dedede"
    />
    <router-view />
  </v-main>
</template>

<script>
export default {
  name: 'HomeView',
  data: () => ({
    particleKey: 0
  }),
  watch: {
    $route: function(to, from) {
      if (to.path !== from.path) {
        this.particleKey += 1
      }
    }
  }
}
</script>

<style scoped>
.vue-particles-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: black;
  opacity: 1;
}
</style>
